import { keyframes, css } from 'styled-components';
var show = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
export var animation = css(["animation:", " 0.2s ease;"], show);